import { psAxios } from '@patsnap/common-ps-http';

export interface TrackEvent {
    source_type?: string;
    other_param?: string;
    event_detail_str?: string;
    module_type?: string;
    event_type?: string;
}

export function track(data: TrackEvent): Promise<any> {
    const defaultData = {
        module_type: 'EUREKA',
    };

    let eventDetail: Record<string, unknown> = {};
    if (data.event_detail_str) {
        try {
            eventDetail = JSON.parse(data.event_detail_str);
        } catch {
            // 解析失败保留原值不处理
        }
    }
    const event_detail_str = JSON.stringify({ ...eventDetail, app_name: 'drafting' });

    return psAxios.post(
        `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/tracking/add`,
        {
            ...defaultData,
            ...data,
            event_detail_str,
        },
        {
            headers: {
                'X-API-VERSION': '1.0',
            },
        },
    ).catch((e) => {
        console.warn('trackApi error: ', e);
    });
};


